function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PointLocation from '../../algorithm/PointLocation';
import TopologyException from '../../geom/TopologyException';
import MaximalEdgeRing from './MaximalEdgeRing';
import ArrayList from '../../../../../java/util/ArrayList';
import Assert from '../../util/Assert';
import PlanarGraph from '../../geomgraph/PlanarGraph';
var PolygonBuilder = /*#__PURE__*/function () {
  function PolygonBuilder() {
    _classCallCheck(this, PolygonBuilder);
    PolygonBuilder.constructor_.apply(this, arguments);
  }
  return _createClass(PolygonBuilder, [{
    key: "sortShellsAndHoles",
    value: function sortShellsAndHoles(edgeRings, shellList, freeHoleList) {
      for (var it = edgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (er.isHole()) {
          freeHoleList.add(er);
        } else {
          shellList.add(er);
        }
      }
    }
  }, {
    key: "computePolygons",
    value: function computePolygons(shellList) {
      var resultPolyList = new ArrayList();
      for (var it = shellList.iterator(); it.hasNext();) {
        var er = it.next();
        var poly = er.toPolygon(this._geometryFactory);
        resultPolyList.add(poly);
      }
      return resultPolyList;
    }
  }, {
    key: "placeFreeHoles",
    value: function placeFreeHoles(shellList, freeHoleList) {
      for (var it = freeHoleList.iterator(); it.hasNext();) {
        var hole = it.next();
        if (hole.getShell() === null) {
          var shell = this.findEdgeRingContaining(hole, shellList);
          if (shell === null) throw new TopologyException('unable to assign hole to a shell', hole.getCoordinate(0));
          hole.setShell(shell);
        }
      }
    }
  }, {
    key: "buildMinimalEdgeRings",
    value: function buildMinimalEdgeRings(maxEdgeRings, shellList, freeHoleList) {
      var edgeRings = new ArrayList();
      for (var it = maxEdgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (er.getMaxNodeDegree() > 2) {
          er.linkDirectedEdgesForMinimalEdgeRings();
          var minEdgeRings = er.buildMinimalRings();
          var shell = this.findShell(minEdgeRings);
          if (shell !== null) {
            this.placePolygonHoles(shell, minEdgeRings);
            shellList.add(shell);
          } else {
            freeHoleList.addAll(minEdgeRings);
          }
        } else {
          edgeRings.add(er);
        }
      }
      return edgeRings;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(p) {
      for (var it = this._shellList.iterator(); it.hasNext();) {
        var er = it.next();
        if (er.containsPoint(p)) return true;
      }
      return false;
    }
  }, {
    key: "buildMaximalEdgeRings",
    value: function buildMaximalEdgeRings(dirEdges) {
      var maxEdgeRings = new ArrayList();
      for (var it = dirEdges.iterator(); it.hasNext();) {
        var de = it.next();
        if (de.isInResult() && de.getLabel().isArea()) {
          if (de.getEdgeRing() === null) {
            var er = new MaximalEdgeRing(de, this._geometryFactory);
            maxEdgeRings.add(er);
            er.setInResult();
          }
        }
      }
      return maxEdgeRings;
    }
  }, {
    key: "placePolygonHoles",
    value: function placePolygonHoles(shell, minEdgeRings) {
      for (var it = minEdgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (er.isHole()) {
          er.setShell(shell);
        }
      }
    }
  }, {
    key: "getPolygons",
    value: function getPolygons() {
      var resultPolyList = this.computePolygons(this._shellList);
      return resultPolyList;
    }
  }, {
    key: "findEdgeRingContaining",
    value: function findEdgeRingContaining(testEr, shellList) {
      var testRing = testEr.getLinearRing();
      var testEnv = testRing.getEnvelopeInternal();
      var testPt = testRing.getCoordinateN(0);
      var minShell = null;
      var minEnv = null;
      for (var it = shellList.iterator(); it.hasNext();) {
        var tryShell = it.next();
        var tryRing = tryShell.getLinearRing();
        var tryEnv = tryRing.getEnvelopeInternal();
        if (minShell !== null) minEnv = minShell.getLinearRing().getEnvelopeInternal();
        var isContained = false;
        if (tryEnv.contains(testEnv) && PointLocation.isInRing(testPt, tryRing.getCoordinates())) isContained = true;
        if (isContained) {
          if (minShell === null || minEnv.contains(tryEnv)) {
            minShell = tryShell;
          }
        }
      }
      return minShell;
    }
  }, {
    key: "findShell",
    value: function findShell(minEdgeRings) {
      var shellCount = 0;
      var shell = null;
      for (var it = minEdgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (!er.isHole()) {
          shell = er;
          shellCount++;
        }
      }
      Assert.isTrue(shellCount <= 1, 'found two shells in MinimalEdgeRing list');
      return shell;
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1) {
        var graph = arguments[0];
        this.add(graph.getEdgeEnds(), graph.getNodes());
      } else if (arguments.length === 2) {
        var dirEdges = arguments[0];
        var nodes = arguments[1];
        PlanarGraph.linkResultDirectedEdges(nodes);
        var maxEdgeRings = this.buildMaximalEdgeRings(dirEdges);
        var freeHoleList = new ArrayList();
        var edgeRings = this.buildMinimalEdgeRings(maxEdgeRings, this._shellList, freeHoleList);
        this.sortShellsAndHoles(edgeRings, this._shellList, freeHoleList);
        this.placeFreeHoles(this._shellList, freeHoleList);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PolygonBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { PolygonBuilder as default };
PolygonBuilder.constructor_ = function () {
  this._geometryFactory = null;
  this._shellList = new ArrayList();
  var geometryFactory = arguments[0];
  this._geometryFactory = geometryFactory;
};